/** 车辆档案详情组件 
 *  创建时间：2017-03-30 
 * 创建人：Shujuan Sun 
 */
<template>                                                                      
	<div id="carfile-detail" class="wrapper-content fadeInRight animated tabBox">
		<div class="ibox-content" v-loading="loadingstatus!=2 && loadingbasicstatus" element-loading-text="加载中">
			<!--顶部表单开始-->
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">车辆ID</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.vehicleName">
					</div>
					<label class="col-sm-1 control-label">服务卡号</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.vehicleAccount">
					</div>
					<label class="col-sm-1 control-label">当前里程</label>
					<div class="col-sm-2">
						<div class="input-group">
		                    <input type="text" class="form-control" readonly v-model="vehicleInfo.totalMileage"> 
		                    <span class="input-group-btn"> 
		                    	<button v-if="permission.indexOf('fileCarList_calibrate') == -1"  type="button" class="btn btn-primary" @click="openSubPage">校准</button> 
		                    </span>
		                </div>
					</div>
					<label class="col-sm-1 control-label">当前所在城市</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.posCity">
					</div>
				</div>
			</div>
			<!--顶部表单结束-->
			<div class="gray-bg pb5px">
				<!--中间tab开始-->
				<ul class="col-sm-12 pl0px pt0px tip_page_tabs" style="overflow:hidden;">
					<li v-for="(subTab,index) in subTabList" @click="goSubTab(index,subTab.route)" class="t_center" :class="{active:currentIndex === index}">
						<a v-text="subTab.name"></a>
					</li>
				</ul>
				<!--中间tab结束-->
				<!--各subTab对应组件渲染区域-->
				<!-- <router-view name="detail"></router-view> -->
				<keep-alive>
					<component v-bind:is="currentView" style="clear:both;">
					  	<!-- 组件在 vm.currentview 变化时改变！ -->
					</component>
				</keep-alive>
			</div>
		</div>
		<!--   弹出框子组件        -->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModal('modalMsg')" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--里程校准输入框-->
		<sub-page :show="toShow" :bigTitleMsg="bigTitle" :scroll='scrollTop' :width='30' v-on:cancel="closeSubPage">
			<div slot="bodycontent">
				<div class="m20px">
					<div class="form-group">
					    <label>请输入当前车辆实际里程</label>
					    <input-number :min="1" :max="1000000" :controls="false" :inputWidth="200" v-model="mileageNum"></input-number>
					</div>
					<div class="form-group text-center">
						<button v-if="permission.indexOf('fileCarList_calibrateSure') == -1" class="btn btn-primary" @click="correctMileage">确定</button>
					</div>
				</div>
			</div>
		</sub-page>
	</div>
</template>

<script>
	import DetailHome from 'components/pages/didicarfile/detail/DetailHome'
	import DetailBasic from 'components/pages/didicarfile/detail/DetailBasic'
	import DetailDevice from 'components/pages/didicarfile/detail/DetailDevice'
	import DetailOwner from 'components/pages/didicarfile/detail/DetailOwner'
	import DetailAlarm from 'components/pages/didicarfile/detail/DetailAlarm'
	import DetailObd from 'components/pages/didicarfile/detail/DetailObd'
	import DetailMessage from 'components/pages/didicarfile/detail/DetailMessage'
	import DetailRecord from 'components/pages/didicarfile/detail/DetailRecord'
	import InputNumber from 'components/common/InputNumber'
	import SubPage from 'components/common/SubPage'
    import TabModal from 'components/common/TabModal'
    import { OPERATE_EXCEPTION } from 'static/message'
    import classlist from 'util/classlist'
    
	export default {
		name: 'PageFileCarDetail',
		components: {
			DetailHome,
			DetailBasic,
			DetailDevice,
			DetailOwner,
			DetailAlarm,
			DetailObd,
			DetailMessage,
			DetailRecord,
			InputNumber,
			TabModal,
			SubPage
		},
		// 接收参数车辆ID
		created(){
			this.vehicleInfo.vehicleId = this.$route.query.id;
		},
		// 组件初始化
		beforeMount(){
			this.getBasicInfo();
			this.initPermission();
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				loadingstatus:0,
				loadingbasicstatus:false,
				vehicleInfo: {	
					vehicleId: '',			// 当前车辆id
					vehicleAccount: "",		// 服务卡号
					totalMileage: "",		// 里程
					posCity: "",			// 当前所在城市
					vehicleName:""			// 显示用
				},
				resultVehicle:{},
				subTabList: [{
					name: "首页",
					route: "detailHome",
					permissionName:"detailHome"
				}, {
					name: "基本信息",
					route: "detailBasic",
					permissionName:"fileCarList_baseInfo"
				}, {
					name: "设备信息",
					route: "detailDevice",
					permissionName:"fileCarList_deviceInfo"
				}, {
					name: "车主信息",
					route: "detailOwner",
					permissionName:"fileCarList_vehicleOwner"
				 }, //{
				// 	name: "车辆报警",
				// 	route: "detailAlarm",
				// 	permissionName:"fileCarList_vehicleAlarm"
				// },
				{
					name: "OBD故障",
					route: "detailObd",
					permissionName:"fileCarList_error"
				}, {
					name: "设备报文",
					route: "DetailMessage",
					permissionName:"fileCarList_deviceMessage"
				}, {
					name: "变更记录",
					route: "DetailRecord",
					permissionName:"fileCarList_changeLog"
				}],
				currentIndex: 0,
				messageStr: "",					// 弹出框内容
				scrollTop: "0px",
				toShow: false, 					//里程弹框是否显示
				bigTitle: '里程校准', 			//里程弹框标题
				mileageNum:1,					//校准里程数
				currentView: "detailHome",
				vehicleDel:false
			};
		},
		methods: {
			initPermission(){
				let that = this;
				this.permission.forEach(function(item, i) {
					let index = that.subTabList.findIndex(function(value, index, arr) {
					   return value.permissionName == item;
					});
					if (index != -1){
						that.subTabList.splice(index,1);
					}
				});
			},
			goSubTab(index, route) {
				this.currentView = route;
				this.$store.dispatch('fileSubTab',route)
				this.currentIndex = index;
			},
			// 获取车辆基本详情：服务卡号，里程，城市
			getBasicInfo(){
				this.loadingbasicstatus = true;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/'+ this.vehicleInfo.vehicleId)
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.resultVehicle = resInfo;
						this.vehicleInfo.vehicleAccount = resInfo.vehicleAccount;
						this.vehicleInfo.totalMileage = resInfo.totalMileage;
						this.vehicleInfo.posCity = resInfo.posCity;
						this.vehicleInfo.vehicleName = resInfo.vehicleIdText;
						this.mileageNum = this.vehicleInfo.totalMileage;
					}else{ 
						this.openModal(res.body.message);
					}
					this.loadingbasicstatus = false;
				}, res => { 
						if(res.body.message=='车辆信息有误'){
							this.vehicleDel = true
						}
						this.openModal(res.body.message);
						this.loadingbasicstatus = false;
				}).catch( res => { 
					this.openModal(OPERATE_EXCEPTION);
					this.loadingbasicstatus = false;
				})
			},
			// 里程校准
			correctMileage(){
				const param = {
					vehicleId:this.vehicleInfo.vehicleId,
					mileage:this.mileageNum
				}

				this.closeSubPage();
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/mileage', param)
				.then( res => {
					if(res.body.success){
						this.mileageNum = res.body.data;
						this.vehicleInfo.totalMileage = res.body.data;
					}else{
						this.openModal(res.body.message);
					}
				}, res => {
						this.openModal(res.body.message);
				}).catch( res => {
					this.openModal(OPERATE_EXCEPTION);
				})
			},
			// 打开里程校准弹框
			openSubPage(){
				this.toShow = true;
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			// 关闭里程校准弹框
			closeSubPage() { 
				this.toShow = false;
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			// 消息弹出框相关
			openModalMaster(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#carfile-detail',this);
        	},
        	closeModalMaster(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#carfile-detail',this);
        	},
        	closeModal(){
        		this.closeModalMaster("modalMsg");
        		if(this.vehicleDel){
					for(var i = 0; i < this.$store.state.home.tabList.length; i++) {
						 if(this.$store.state.home.tabList[i].id == "PageFileCarDetail"){
						 	this.$store.dispatch('closeTab',i);
	                        this.$router.push(this.$store.state.home.path);
						}
					}
			
        		}
        	},
        	openModal(message){
        		this.messageStr = message;
        		this.openModalMaster("modalMsg")
        	}
		}
		
	};
</script>
<style scoped>
	ul li {
		float: left;
		padding: 5px 10px;
		list-style: none;
	}
	
	ul {
		border: 1px solid #ccc;
	}
	
	li {
		border-right: 1px solid #ccc;
	}
	
	li.active {
		background-color: #000;
	}
</style>


// WEBPACK FOOTER //
// PageFileCarDetail.vue?0de93a72